import React from 'react'

import { Field } from 'formik'

import { Form, Col } from '_zari/core'

const SerieNumeroFormGroup = ({ fIsSubmitting }) => {
  return (
    <>
      <Form.Group>
        <Form.Label text='SERIE' htmlFor='input-serieDocumento' md={4} />
        <Col md={4}>
          <Field name='serieDocumento'>
            {({ field }) => (
              <Form.InputText
                {...field}
                id='input-serieDocumento'
                disabled={fIsSubmitting}
                className='zr-text-upper'
                maxLength={4}
              />
            )}
          </Field>
        </Col>
        <Col md={4} className='pl-0'>
          <Field name='numeroDocumento'>
            {({ field }) => (
              <Form.InputText {...field} id='input-numeroDocumento' disabled={fIsSubmitting} />
            )}
          </Field>
        </Col>
      </Form.Group>
    </>
  )
}

export default React.memo(SerieNumeroFormGroup)
